import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import Box from '@magalu/stereo-ui/atoms/Box';
import Flex from '@magalu/stereo-ui/atoms/Flex';
export var Container = styled(Box).attrs(function (props) {
  return _extends({}, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var FlexList = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  gap: 8px;\n  overflow-x: scroll;\n\n  & > a:hover,\n  & > a:focus,\n  & > a:active {\n    border: 1px solid #d3dadd;\n  }\n\n  & > * {\n    min-width: 100px;\n\n    & h2 {\n      color: #697277;\n      margin-top: 4px;\n    }\n  }\n"])));